import { Send } from 'lucide-react'
import { useSendBulkReceiptsMutation } from '../hooks/useSendBulkReceiptsMutation'
import { useIsMobile } from '@/hooks'
import LoadingButton from '@/components/custom/loading-button'
import { useDonationsStore } from '@/features/donations/store/donationsStore'

const SendBulkReceiptsButton = () => {
  const isMobile = useIsMobile()
  const { mutateAsync: sendBulkReceipts, isPending: isSendingReceipts } =
    useSendBulkReceiptsMutation()

  const donations = useDonationsStore((s) => s.donations)
  const unsentReceipts = donations.filter(
    (donation) => donation.status === 'verified' && !donation.sentToMember,
  )

  const handleClick = async () => {
    try {
      await sendBulkReceipts()
    } catch (error) {
      console.error('Error sending bulk receipts', error)
    }
  }

  if (unsentReceipts.length === 0) return null

  // Button is always shown, since receipts are fetched server-side
  return (
    <LoadingButton
      className={`text-xs ${isMobile ? 'w-full justify-center' : 'ml-2'}`}
      onClick={handleClick}
      disabled={isSendingReceipts}
      isLoading={isSendingReceipts}
    >
      <Send className="h-4 w-4" />
      {isSendingReceipts ? 'Processing...' : 'Send All'}
    </LoadingButton>
  )
}
export default SendBulkReceiptsButton
